/*
Say something politely to assistive technology from inside the open drawer
(XOL-596, completed steps: "Step 3 was completed by {User name}. It's now read-only.").

LayerHost renders an empty `.layer-host__live-region` (role="status", aria-live="polite")
inside every drawer, which sits inside the aria-modal dialog, so VoiceOver reads it. The
TOPMOST drawer's region is the last one in the document. The text is cleared and set on
the next tick, so a repeated message is spoken again. With no drawer open (a spec, a
page without LayerHost) the C-12 card's own polite region speaks instead.

ES5, no optional chaining or nullish coalescing.
------------------------------------------------------------------------ */

import { say } from '@/lib/savePopup'

// The pending write of the last announcement: a newer one, or a drawer that went away
// meanwhile, must not write into a stale region.
var timer = null

export function announceInDrawer (text) {
  var regions = typeof document !== 'undefined' ? document.querySelectorAll('.layer-host__live-region') : []

  if (!regions || regions.length === 0) {
    say(text, false)

    return
  }

  var region = regions[regions.length - 1]

  region.textContent = ''

  if (timer) {
    clearTimeout(timer)
  }

  timer = setTimeout(function () {
    timer = null

    if (region.isConnected !== false) {
      region.textContent = text
    }
  }, 0)
}
